import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const ProfessionalProfile = () => {
  const { id } = useParams();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Perfil del Profesional
        </Typography>
        <Typography variant="body1">
          Mostrando perfil del profesional con ID: {id}
        </Typography>
      </Box>
    </Container>
  );
};

export default ProfessionalProfile;